export default __webpack_public_path__ + "static/media/industria.236d3167.jpg";